import React from 'react';
import { SearchkitProvider, SearchkitClient } from './searchkit';

var defaultSearchkitClient = function defaultSearchkitClient() {
  return new SearchkitClient();
};

export default (function (Page) {
  var createSearchkitClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSearchkitClient;
  var _client = null;

  var getClient = function getClient() {
    if (!_client) {
      _client = createSearchkitClient();
    }

    return _client;
  };

  var withSearchkit = function withSearchkit(props) {
    var client = getClient();

    if (props.searchState) {
      var searchState = props.searchState;
      client.updateBaseSearchState(searchState);
    }

    return React.createElement(SearchkitProvider, {
      client: getClient()
    }, React.createElement(Page, Object.assign({}, props)));
  };

  withSearchkit.getInitialProps = function (ctx) {
    ctx.searchkitClient = getClient();

    if (Page.getInitialProps) {
      return Page.getInitialProps(ctx);
    }

    return {};
  };

  return withSearchkit;
});